<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.supplierId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined" :hideOverlayRoute="$route.params.supplierId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getSupplierListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="100" :open-function="openItem" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)" />
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/components/ListItems/SupplierListItem.vue";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";

export default {
  name: "AdminSuppliers",
  props: {},
  components: {
    ListPane,
    FilterPane,
    Layout,
    ListItem,
    DefaultLifeCycleFilterGroup,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "SL-",
    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "Suppliers") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewSupplier', params: { supplierId: item.Id }, query })
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },
  },

  watch: {},
};
</script>